import { render, staticRenderFns } from "./ShowOrderPayment.vue?vue&type=template&id=22b57123&scoped=true&"
import script from "./ShowOrderPayment.vue?vue&type=script&lang=js&"
export * from "./ShowOrderPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b57123",
  null
  
)

export default component.exports